import React, { useEffect, useState } from 'react';
import {
    REMOVE_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_CART_LOADER_DATA_OBJECT
} from "../../../store/slice/model/Cart";
import { useDispatch } from "react-redux";
import ProductPricingRepository from "../../../repository/ProductPricingRepository";
import Common from "./Common";
import ProductInventoryRepository from "../../../repository/ProductInventoryRepository";
import { isArray } from "underscore";
import { Tooltip } from "../../Tooltip";
import System from 'src/helper/system';
import Constants from 'src/support/Constants';
import Helper from 'src/support/Helper';
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useCartStore } from 'src/hooks/cart';
import CartRepository from 'src/repository/CartRepository';
import CommonCart from "src/component/Global/Cart/Common";

// DT - 16/3 - 9746: While entering more than 35 characters on manually add cpn text box and clicking on submit then it allowing and displaying all characters on different places
// DT - 21/3 - set manual/choose CPN onload
// DT - 27/3 - 9874: While uploading BOM with different CPN of same part then CPN displaying same on CPN column in exact match of BOM details
const CustomerPartNumberOptions = (props) => {
    const dispatch = useDispatch();
    const { disabled, displayManualCpn, callFrom, single_cpn_data, single_product, auto_select_from_cart_data = true } = props;

    let c = System.getParams();
    // const [isTypeUpdate, setIsTypeUpdate] = useState(false)
    const [switchingCpn, setSwitchingCpn] = useState(false)
    const [selectedCpnOption, setSelectedCpnOption] = useState('');
    const [manuallyCpnValue, setManuallyCpnValue] = useState('');
    const isCPNListExists = single_product?.CustomerPartNumbers?.length > 0 ? true : false;

    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [{ pricingList }, { fetch_product_pricing_list }, { }] = useProductPricingStore();
    const pricing = pricingList
    const get_single_product_pricing_list = () => {
        if (props.single_product_pricing_list !== undefined) {
            return props.single_product_pricing_list;
        }
        return pricing && (pricing[ERPMFRPartNumber]) !== undefined ? pricing[ERPMFRPartNumber] : [];
    };
    const single_product_pricing_list = get_single_product_pricing_list();
    const ItemNumber = single_product.ItemNumber
    const uniqueId = props.bom_detail_id ? props.bom_detail_id : ItemNumber


    useEffect(() => {
        if (get_selected_status) {
            dispatch(SET_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
                CART_DATA: {
                    ItemNumber: ItemNumber,
                    CUSTOMER_PART_NUMBER: get_selected_status
                }
            }));
        }
    }, [])

    const updateToCartServer = async (SELECTED_CUSTOMER_PART_NUMBER, callPricing = true, userSelectedOptionFromDropDown = true, clickManualAddCpn = false) => {
        if (props.updationStartedCallback !== undefined) {
            props.updationStartedCallback();
        }
        dispatch(SET_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
            CART_DATA: {
                ItemNumber: ItemNumber,
                CUSTOMER_PART_NUMBER: SELECTED_CUSTOMER_PART_NUMBER
            }
        }));

        dispatch(REMOVE_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
            CART_DATA: {
                ItemNumber: ItemNumber
            }
        }));

        if (callPricing === true) {

            if (single_product) {
                let params = [];

                params.push({
                    partNumber: single_product?.ERPPartNumberModified ? '' : single_product.ERPPartNumber,
                    erpManufacturerCode: single_product.ERPManufacturerCode,
                    erpMfrPartNumber: single_product.ERPMFRPartNumber,
                    WebCode: single_product.WebCode,
                    ObsoleteFlag: single_product.ObsoleteFlag,
                    customerPartNumber: SELECTED_CUSTOMER_PART_NUMBER ? SELECTED_CUSTOMER_PART_NUMBER : clickManualAddCpn ? '*' : ''
                })

                /**
                 * If click on manual add cpn then send * for price API call
                 * Author: Devanshi Patel
                 */
                let paramSet = await new ProductPricingRepository().getPricingParams(params);
                await fetch_product_pricing_list(paramSet)
            }
        }
        let quantity = await new ProductInventoryRepository().getQuantityFromCartBeforeSendToServerByERPPartNumber(single_product.ItemNumber);
        await new Common().setPricingAutomaticallyBasedOnPricing(quantity, single_product_pricing_list, single_product);

        /**
         * update call only if userSelectedOptionFromDropDown is true
         * Author: Devanshi Patel
         */
        let _isManual = CommonCart.isCpnIsManual(single_product, SELECTED_CUSTOMER_PART_NUMBER);
        if (props.updationCompletedCallback !== undefined && userSelectedOptionFromDropDown === true) {
            props.updationCompletedCallback(SELECTED_CUSTOMER_PART_NUMBER, _isManual ? Constants.cpnTypes.MANUALCPN : Constants.cpnTypes.CPN);
        }
        if (props.updationCompletedBasedOnUserSelectionOnlyCallback !== undefined && userSelectedOptionFromDropDown === true) {
            props.updationCompletedBasedOnUserSelectionOnlyCallback(SELECTED_CUSTOMER_PART_NUMBER, Constants.cpnTypes.CPN);
            if (callFrom === Constants.systemModules.BOM) {
                props.updateCpnBom(SELECTED_CUSTOMER_PART_NUMBER, Constants.cpnTypes.CPN)
            }
        }
    };

    /**
     * Author :Trilok
     * Date: 03/10/2023
     * Reason: Update redux with default selected
     */

    const setCPNtoCartRedux = (cpn) => {
        dispatch(SET_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
            CART_DATA: {
                ItemNumber: ItemNumber,
                // ERPPartNumber: ERPPartNumberWithContract,
                CUSTOMER_PART_NUMBER: cpn
            }
        }));
    }

    const getSelectedStatus = () => {
        // console.log("props.defaultValue")
        let h = auto_select_from_cart_data;

        // console.log("================single_cpn_data ", single_cpn_data)
        if (single_cpn_data?.cpnTypeName === Constants.cpnTypes.CPN && (single_cpn_data?.cpn || single_cpn_data?.customerPartNumber)) {
            return single_cpn_data.cpn ? single_cpn_data.cpn.toUpperCase() : single_cpn_data.customerPartNumber.toUpperCase()
        } else if (single_cpn_data?.cpnTypeName === Constants.cpnTypes.MANUALCPN) {
            return single_cpn_data?.manualCPN
        } else {
            if (isCPNListExists) {
                // console.log("switchingCpn ", switchingCpn)
                if (!switchingCpn) {
                    const searchTermFromUrl = c.search || c.searchTerm;
                    const cpnFromSearchTerm = single_product.CustomerPartNumbers?.find(
                        (x) => x?.CPN?.replace(/\s/g, "")?.toLowerCase() == searchTermFromUrl?.replace(/\s/g, "")?.toLowerCase()
                    );
                    if (cpnFromSearchTerm) {
                        // console.log("220")
                        return cpnFromSearchTerm?.CPN
                    }
                    // else if (callFrom === Constants.systemModules.BOM && props.defaultValue === null) {
                    //     console.log("220 update")
                    //     return single_product.CustomerPartNumbers[0].CPN
                    // }
                    else if (props.defaultValue) {
                        // console.log("222")
                        return props.defaultValue;
                    }
                }
                // console.log("isTypeUpdate ", isTypeUpdate)
                const storedCPN = new CartRepository().getCustomerPartNumberFromERPPArtNumber(ItemNumber);
                const receivedCPNOutFromList = single_product_pricing_list && single_product_pricing_list.find((x) => x.customerPartNumberOut !== "");
                if (receivedCPNOutFromList && Object.entries(receivedCPNOutFromList)?.length > 0 && Helper.valueIsNotNull(receivedCPNOutFromList?.customerPartNumberOut) === true) {
                    // console.log("229")
                    return receivedCPNOutFromList?.customerPartNumberOut;
                } else if (storedCPN) {
                    // console.log("232")
                    return storedCPN;
                } else {
                    // console.log("240 list")
                    return (Helper.valueIsNotNull(manuallyCpnValue)) ? manuallyCpnValue : single_product.CustomerPartNumbers[0].CPN;
                }

            } else {
                if (!switchingCpn) {
                    if (props.defaultValue) {
                        // console.log("241")
                        return props.defaultValue;
                    }
                }
                const storedCPN = new CartRepository().getCustomerPartNumberFromERPPArtNumber(ItemNumber);
                if (storedCPN) {
                    // console.log("251")
                    return storedCPN;
                } else {
                    // console.log("255 list", Helper.valueIsNotNull(manuallyCpnValue) ? manuallyCpnValue : "")
                    return Helper.valueIsNotNull(manuallyCpnValue) ? manuallyCpnValue : "";
                }
            }
        }
    };

    const get_selected_status = getSelectedStatus();

    const getSelectedMessage = () => {
        let m = get_selected_status;
        let m_f = false;
        if (m && single_product_pricing_list && isArray(single_product_pricing_list) && single_product_pricing_list.length > 0) {
            single_product_pricing_list.map((v) => {
                if (m_f !== false) {
                    return;
                }
                if (m === v.customerPartNumber) {
                    if (v.message) {
                        m_f = v.message;
                    }
                }
            })
        }
        return m_f;
    };

    const onApplyManualCpn = (cpnData, isSelectManualOption = false) => {
        /**
         * As discussed with Basav when manually add cpn is  '' send '*' as cpn value for update in database
         * Author: Devanshi Patel
         */
        let selectedCPN = ''
        if (cpnData) {
            selectedCPN = cpnData
        } else if (single_cpn_data?.manualCPN && isSelectManualOption) {
            selectedCPN = single_cpn_data?.manualCPN
        } else {
            selectedCPN = manuallyCpnValue === '' ? '' : manuallyCpnValue
        }

        let _isManual = CommonCart.isCpnIsManual(single_product, selectedCPN);

        if (props.updationCompletedCallback !== undefined) {
            props.updationCompletedCallback(selectedCPN, _isManual ? Constants.cpnTypes.MANUALCPN : Constants.cpnTypes.CPN);
        }
        if (props.updationCompletedBasedOnUserSelectionOnlyCallback !== undefined) {
            props.updationCompletedBasedOnUserSelectionOnlyCallback(selectedCPN, _isManual ? Constants.cpnTypes.MANUALCPN : Constants.cpnTypes.CPN);
        }
        if (callFrom === Constants.systemModules.BOM) {
            props.updateCpnBom(selectedCPN, Constants.cpnTypes.MANUALCPN)
        }
    }

    useEffect(() => {
        if (single_cpn_data?.cpnTypeName === Constants.cpnTypes.CPN) {
            setSelectedCpnOption(Constants.cpnTypes.CPN)
        } else if (single_cpn_data?.cpnTypeName === Constants.cpnTypes.MANUALCPN) {
            setSelectedCpnOption(Constants.cpnTypes.MANUALCPN)
            setManuallyCpnValue(single_cpn_data?.manualCPN)
        } else {
            let selected_cpn = get_selected_status;
            if (isCPNListExists && single_product?.CustomerPartNumbers.filter(e => e.CPN === selected_cpn).length > 0) {
                if (selected_cpn !== '' && selected_cpn !== 'false' && selected_cpn !== false) {
                    setSelectedCpnOption(Constants.cpnTypes.CPN)
                    setCPNtoCartRedux(selected_cpn);
                }
            } else {
                setSelectedCpnOption(Constants.cpnTypes.MANUALCPN)
                setManuallyCpnValue(selected_cpn)
            }
        }
    }, [get_selected_status])

    useEffect(() => {
        async function f() {
            let selected_status = get_selected_status;
            if (props.onChange === undefined && selected_status === false && isCPNListExists && single_product?.CustomerPartNumbers?.length === 1) {
                /**
                 * Update cart server call only when cpn selection is there and only single cpn in list                 
                 * Author: Devanshi Patel                 
                 */
                if (selectedCpnOption === Constants.cpnTypes.CPN) {
                    await updateToCartServer(single_product.CustomerPartNumbers[0].CPN, false)
                }
            }
            if (props.onChange === undefined && selected_status === false && isCPNListExists) {
                if (single_product_pricing_list && isArray(single_product_pricing_list) && single_product_pricing_list.length > 0) {
                    let customerPartNumberOut = false;
                    single_product_pricing_list.map((v_c) => {
                        if (customerPartNumberOut !== false) {
                            return;
                        }
                        /**
                         * In some cases customerpartnumberout is blank from API so we set defalut first cpn when it is blank
                         * Author: Devanshi Patel
                         */
                        if (v_c.customerPartNumberOut) {
                            customerPartNumberOut = v_c.customerPartNumberOut;
                        } else {
                            customerPartNumberOut = single_product.CustomerPartNumbers[0].CPN
                        }

                    })
                    if (customerPartNumberOut && selectedCpnOption !== Constants.cpnTypes.MANUALCPN) {
                        await updateToCartServer(customerPartNumberOut, false)
                    }
                }
            }
        }

        f()
    }, [
        single_product?.CustomerPartNumbers,
        single_product_pricing_list,
        CART_BEFORE_TO_SEND_SERVER[single_product?.ItemNumber],
    ]);
    const onSelectCPNType = async (type) => {
        setSelectedCpnOption(type);
        // setIsTypeUpdate(true);
        let _cpn = type === Constants.cpnTypes.MANUALCPN ? (single_cpn_data?.manualCPN) : (single_cpn_data.cpn ? single_cpn_data.cpn : single_cpn_data.customerPartNumber);
        let isPriceCall = callFrom === Constants.systemModules.Quote ? false : true;
        if (type === Constants.cpnTypes.MANUALCPN) {
            await updateToCartServer(_cpn, isPriceCall, false, true)
        } else {
            await updateToCartServer(_cpn, isPriceCall, true)
        }
    }

    const onSelectCPN = async (cpnVal) => {
        dispatch(SET_CART_LOADER_DATA_OBJECT({ ...single_product, isUpdatingCpnType: !single_product?.isUpdatingCpnType }))
        setSwitchingCpn(true)
        if (props.onChange !== undefined) {
            props.onChange(cpnVal);
        } else {
            await updateToCartServer(cpnVal, true, true)
        }
    }

    const SelectedMessage = getSelectedMessage();

    const onManuallyCpnChange = (e) => {
        dispatch(SET_CART_LOADER_DATA_OBJECT({}))
        setManuallyCpnValue(Helper.toUpperCase(e.target.value))
    }

    const cpnLabelTooltip = () => {
        /**
        * Tooltip display only when more than one CPN is available
        * Author: Devanshi Patel
        */
        if (single_product?.CustomerPartNumbers?.length > 1) {
            if (SelectedMessage) {
                return getSelectedMessage();
            }

            return 'Click the drop down to select another Customer Part Number';
        } else {
            return 'This is an optional field for your reference only. The value entered is for this order only and will not be saved for future orders.';
        }
    }

    return (
        /**
         * When webcode is 4 display cpn or manual add not display price
         * Author: Devanshi Patel
         */
        <>
            <div className="form-group">
                {((displayManualCpn || isCPNListExists)) &&
                    <label htmlFor="sel1" className="text-nowrap"><b>Customer Part Number</b>
                        <Tooltip
                            opener={() => (<i className="fa fa-info-circle ms-1" />)}
                            content={() => (
                                <>
                                    { cpnLabelTooltip() }
                                </>
                            )}
                        />
                    </label>
                }

                {/**
                * Changes for manually add cpn
                * Author/; Devanshi patel
                 */}
                {displayManualCpn && isCPNListExists &&
                    <div className='cpn-manually-checkbox'>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio"
                                name={"cpnOption-" + uniqueId} id={"cpn-" + uniqueId} value={Constants.cpnTypes.CPN}
                                onChange={async (e) => {
                                    dispatch(SET_CART_LOADER_DATA_OBJECT({ ...single_product, isUpdatingCpnType: !single_product?.isUpdatingCpnType }))
                                    await onSelectCPNType(e.target.value)
                                }}
                                checked={selectedCpnOption === Constants.cpnTypes.CPN ? true : false} />
                            <label className="form-check-label" htmlFor={"cpn-" + uniqueId}>Choose CPN</label>
                        </div>
                        <div className="form-check form-check-inline me-0">
                            <input className="form-check-input" type="radio" name={"cpnOption-" + uniqueId} id={"mpn-" + uniqueId} value={Constants.cpnTypes.MANUALCPN}
                                onChange={async (e) => {
                                    dispatch(SET_CART_LOADER_DATA_OBJECT({ ...single_product, isUpdatingCpnType: !single_product?.isUpdatingCpnType }))
                                    setSelectedCpnOption(e.target.value);
                                    await updateToCartServer(manuallyCpnValue, true, false, true);
                                }}
                                onClick={() => onApplyManualCpn('', true)}
                                checked={selectedCpnOption === Constants.cpnTypes.MANUALCPN ? true : false} />
                            <label className="form-check-label" htmlFor={"mpn-" + uniqueId}>Manually Add</label>
                        </div>
                    </div>
                }
                {(selectedCpnOption === Constants.cpnTypes.CPN || !displayManualCpn) && single_product?.CustomerPartNumbers?.length > 1 &&
                    <>
                        <div className="selectbox">
                            <select
                                disabled={disabled}
                                className="form-control form-control-xs"
                                onChange={async (e) => { onSelectCPN(e.target.value) }}
                                value={get_selected_status}
                                id="Customer" aria-labelledby="Choose CPN">
                                {single_product?.CustomerPartNumbers.map((v, i) => (
                                    <React.Fragment key={i}>
                                        <option value={v.CPN}>{v.CPN}</option>
                                    </React.Fragment>
                                ))}
                            </select>
                        </div>
                    </>
                }

                {(selectedCpnOption === Constants.cpnTypes.CPN || !displayManualCpn) &&
                    single_product?.CustomerPartNumbers?.length === 1 &&
                    <>
                        <div className="">
                            <label>{single_product.CustomerPartNumbers[0].CPN}</label>
                        </div>
                    </>
                }

                {((selectedCpnOption !== Constants.cpnTypes.CPN) && displayManualCpn) &&
                    <div className='cpn-manually-input '>
                        <div className='bs5 d-flex align-items-center'>
                            {/**
                             * As discussed with basav when manuallyCpnValue = '*' replace with ''
                             * Author: Devanshi Patel
                             */}
                            <input className="form-control form-control-xs" aria-labelledby="Manually Add CPN" type="text" placeholder="ex. 4353ES" maxLength={35}
                                value={manuallyCpnValue === '*' ? '' : manuallyCpnValue}
                                onChange={(e) => {
                                    onManuallyCpnChange(e)
                                }}
                                onBlur={(e) => onApplyManualCpn(Helper.toUpperCase(e.target.value))}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                }
            </div>
        </>


    );
};

export default CustomerPartNumberOptions;